module.exports = __webpack_public_path__ + "static/Speeches-d3a87f14c054f4b81b90b71b5293754b.mp4";